<template>
    <form class="benefits-faq-form">
        <label class="benefits-faq-field" for="benefits-faq-question">
            <span>
                {{ questionLabel }}
                <strong aria-hidden="true">*</strong>
            </span>

            <KvInput
                id="benefits-faq-question"
                v-model="internalValue.question"
                variant="outlined"
                size="large"
                :placeholder="$root.t('benefitsCenter-faq-questionPlaceholder')"
                @input="emitChange"
            />
        </label>

        <div class="benefits-faq-field">
            <span>{{ answerLabel }}</span>

            <BenefitsRichText v-model="internalValue.answer"
                :placeholder="$root.t('benefitsCenter-faq-answerPlaceholder')" height="200px"
                @input="emitChange" />
        </div>
    </form>
</template>

<script>
import BenefitsRichText from "../../shared/benefits-rich-text.vue";
import KvInput from "../../../components/inputs/kv-input.vue";

export default {
    name: "BenefitsFaqForm",
    components: {
        BenefitsRichText,
        KvInput,
    },
    model: {
        prop: "value",
        event: "input",
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        questionLabel: {
            type: String,
            required: true,
        },
        answerLabel: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            internalValue: this.normalizeValue(this.value),
        };
    },
    watch: {
        value: {
            deep: true,
            handler(value) {
                this.internalValue = this.normalizeValue(value);
            },
        },
    },
    methods: {
        normalizeValue(value) {
            return {
                question: value.question || "",
                answer: value.answer || "",
            };
        },
        emitChange() {
            this.$emit("input", {
                ...this.internalValue,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.benefits-faq-form {
    display: flex;
    flex-direction: column;
    gap: 18px;
    width: 100%;
}

.benefits-faq-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;

    span {
        color: #384250;
        font-family: "Sora", sans-serif;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.3;
    }

    strong {
        color: #f04438;
        font-family: "Inter", sans-serif;
        font-size: 14px;
        font-weight: 400;
    }

    ::v-deep .kv-input,
    ::v-deep .kv-editor {
        width: 100%;
    }
}
</style>